/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Box, Flex, Footer, Table } from '@sonyged/proc-ui';
import { ProcModal } from '@sonyged/ext-proc';
import { css } from '@styled-system/css';

import { ContentScroll } from '../../../../common/components/ContentScroll';
import { Random, Rng } from '../../../utils/Random';
import { Tab } from '../../../../common/components/Tab/Tab';
import { Tabs } from '../../../../common/components/Tab/Tabs';
import Constants from '../../ice/fields/Constants';
import RubyText from '../../common/RubyText';
import pizza_kyaku_ic_c01 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_ic_c01@3x.png';
import pizza_kyaku_ic_c02 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_ic_c02@3x.png';
import pizza_kyaku_ic_c03 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_ic_c03@3x.png';
import pizza_kyaku_ic_f01 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_ic_f01@3x.png';
import pizza_kyaku_ic_f02 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_ic_f02@3x.png';
import pizza_kyaku_ic_f03 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_ic_f03@3x.png';
import pizza_kyaku_ic_m01 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_ic_m01@3x.png';
import pizza_kyaku_ic_m02 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_ic_m02@3x.png';
import pizza_kyaku_ic_m03 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_ic_m03@3x.png';

const randomChild = Random.of(pizza_kyaku_ic_c01, pizza_kyaku_ic_c02, pizza_kyaku_ic_c03);
const randomMale = Random.of(pizza_kyaku_ic_m01, pizza_kyaku_ic_m02, pizza_kyaku_ic_m03);
const randomFemale = Random.of(pizza_kyaku_ic_f01, pizza_kyaku_ic_f02, pizza_kyaku_ic_f03);
const randomAdult = Random.int(0, 1).bind(i => [randomMale, randomFemale][i]);
const randomCustomer = Random.int(0, 2).bind(i => [randomChild, randomMale, randomFemale][i]);

function makeComments() {
  return [
    [randomCustomer.gen(new Rng(Math.random())), '暑い日は、アイスを食べたくなるよね。'],
    [randomCustomer.gen(new Rng(Math.random())), 'バニラは、おとなも子どもも[好|す]きだよね。'],
    [randomChild.gen(new Rng(Math.random())), 'バナナ味が[好|す]き！'],
    [randomMale.gen(new Rng(Math.random())), 'チョコ味だとついつい買っちゃうよ。'],
    [randomFemale.gen(new Rng(Math.random())), 'イチゴ味をよく買いますね。'],
    [randomAdult.gen(new Rng(Math.random())), '土日は、お出かけしてることが多いかな。'],
    [randomChild.gen(new Rng(Math.random())), '雨の日の動物園はすいているよ。'],
    [randomAdult.gen(new Rng(Math.random())), '平日は会社に行くよ。'],
    [randomChild.gen(new Rng(Math.random())), '動物園って平日は子どもが多いよね。'],
    [randomFemale.gen(new Rng(Math.random())), '休日は、ショッピングすることが多いかな。'],
  ];
}

function getcustomerPlaceData(day: number) {
  if (day === Constants.WEEKDAY_SATURDAY || day === Constants.WEEKDAY_SUNDAY)
    return [
      ['動物園', '多い', '多い'],
      ['会社の前', '少ない', '少ない'],
      ['ショッピングモール', 'ふつう', 'ふつう'],
    ];
  else
    return [
      ['動物園', '多い', '少ない'],
      ['会社の前', '少ない', '多い'],
      ['ショッピングモール', 'ふつう', 'ふつう'],
    ];
}

type Props = {
  isOpen: boolean,
  onClose: Function,
  day: number,
};
export function HistoricalInfoModal(props: Props) {
  let { isOpen, onClose, day } = props;

  let comments = React.useMemo(makeComments, []);
  let customerPlaceData = React.useMemo(() => getcustomerPlaceData(day), [day]);

  return (
    <ProcModal isOpened={isOpen} rootNodeId="proc-ice-fields-root-page">
      <div key="modal" className={'proc-modal proc-modal--hint'}>
        <div className="proc-modal-container">
          <div className={'proc-modal-header'}>お客さんのきろく</div>
          <div className={'proc-modal-contents'} style={{ marginTop: 28, marginBottom: 0 }}>
            <Contents>
              <ModalTabs>
                <Tab title="感想">
                  <ContentScroll flex={1} minHeight={0} gradientHeight={12}>
                    <CommentTable>
                      <tbody>
                        {comments.map(([icon, content], i) => (
                          <tr key={i}>
                            <td>
                              <CustomerSurvey>
                                <CustomerAvatar src={icon} />
                                <SurveyContent>
                                  <RubyText>{content}</RubyText>
                                </SurveyContent>
                              </CustomerSurvey>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </CommentTable>
                  </ContentScroll>
                </Tab>
                <Tab title="人の数">
                  <ContentScroll flex={1} minHeight={0} gradientHeight={12}>
                    <CustomerPlaceTable>
                      <thead>
                        <tr>
                          <th />
                          <th>子ども</th>
                          <th>大人</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerPlaceData.map(([place, child, adult], i) => (
                          <tr key={i}>
                            <td>{place}</td>
                            <td>{child}</td>
                            <td>{adult}</td>
                          </tr>
                        ))}
                      </tbody>
                    </CustomerPlaceTable>
                  </ContentScroll>
                </Tab>
              </ModalTabs>
            </Contents>
          </div>
        </div>
        <Footer shadow={false}>
          <Footer.MainButton onClick={onClose}>とじる</Footer.MainButton>
        </Footer>
      </div>
    </ProcModal>
  );
}

const Contents = styled(Box)(
  css({
    position: 'relative',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    px: 16,
  })
);

const CustomerPlaceTable = styled(Table).attrs({ borderRadius: [8, 8, 15] })(
  css({
    width: '100%',
    color: 'gray100',
    lineHeight: 'title',
    'th, td': {
      px: [12, 12, 16],
      py: [4, 4, 6],
    },
    th: {
      fontSize: [14, 14, 18],
    },
    td: {
      height: [58, 58, 74],
      bg: 'white',
      fontSize: [15, 15, 20],
      textAlign: 'center',
    },
    'td:first-child': {
      width: '30%',
      bg: 'secondary8',
      textAlign: 'left',
    },
  })
);

const CommentTable = styled(Table).attrs({ borderRadius: [8, 8, 15] })(
  css({
    width: '100%',
    fontSize: [13, 13, 20],
    color: 'gray100',

    // iPhone SE
    '@media screen and (max-width: 360px)': {
      fontSize: 12,
    },

    tbody: {
      bg: 'white',
    },

    'th, td': {
      fontWeight: 'normal',
      lineHeight: 'title',
    },
  })
);

const ModalTabs = styled(Tabs)(
  css({
    flex: 1,
    minHeight: 0,
    '.proc-tabbar': {
      mb: [8, 8, 18], // "real" margin are 20/30 because there is also padding of 12 for gradient
    },
  })
);

const CustomerSurvey = styled(Flex)(
  css({
    py: [12, 12, 18],
    pr: [12, 12, 18],
    pl: [6, 6, 8],
  })
);

const CustomerAvatar = styled('img')(
  css({
    size: [28, 28, 42],
  })
);

const ARROW_WIDTH = [6, 6, 8];
const ARROW_TOP = [8, 8, 12];
const SurveyContent = styled(Box)(
  css({
    position: 'relative',
    flex: 1,
    px: [12, 12, 16],
    py: [8, 8, 10],
    ml: [6, 6, 8],
    bg: 'secondary8',
    borderRadius: [4, 4, 5],
    fontSize: [14, 14, 19],
    lineHeight: 'title',
    textAlign: 'left',

    '&::before': {
      content: '""',
      position: 'absolute',
      top: ARROW_TOP,
      left: 0,
      bg: 'secondary8',

      // size^2 = arrowWidth^2 * 2 due to pythagorean theorem
      // size = sqrt(arrowWidth ^ 2 * 2)
      size: ARROW_WIDTH.map(x => (x ? `${Math.sqrt(x * x * 2)}px` : null)),

      // rotate 45deg and scale y
      transformOrigin: `top left`,
      transform: `scaleY(0.75) rotate(45deg)`,
    },
  })
);
